import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/black.png";
import Button from "../ui/Button";

export default function Navbar({
  showHomeOnly = false,
  showFinancialButton = false,
  onOpenFinancial = null,
}) {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const role = currentUser?.role;
  const isAdmin = role === "admin";
  const isStaff = role === "doctor" || role === "assistant";
  const isPatient = role === "patient";
  const isHomeRoute = location.pathname === "/" || location.pathname === "/home";

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const Logo = () => (
    <img
      src={logo}
      alt="Logo"
      className="responsive-logo cursor-pointer"
      onClick={() => navigate("/")}
    />
  );

  const CommonButtons = () => {
    if (!currentUser && location.pathname === "/login") {
      return (
        <Button size="sm" smSize="sm" mdSize="md" variant="secondary" onClick={() => navigate("/")}>
          Home
        </Button>
      );
    }

    if (!currentUser && location.pathname === "/") {
      return (
        <Button size="sm" smSize="sm" mdSize="md" variant="primary" onClick={() => navigate("/login")}>
          Login
        </Button>
      );
    }

    if (!currentUser) {
      if (showHomeOnly) {
        return (
          <Button size="sm" smSize="sm" mdSize="md" variant="secondary" onClick={() => navigate("/")}>
            Home
          </Button>
        );
      }
      return (
        <>
          <Button size="sm" smSize="sm" mdSize="md" variant="primary" onClick={() => navigate("/login")}>
            Login
          </Button>
        </>
      );
    }

    const isPanelRoute = location.pathname === "/admin" || location.pathname === "/user";

    const renderClinicButton = () => {
      if (isPanelRoute) return null;
      if (isPatient) return null;
      return (
        <Button
          key="clinic"
          size="sm"
          smSize="sm"
          mdSize="md"
          variant="primary"
          onClick={() => navigate(isAdmin ? "/admin" : "/user")}
        >
          Clinic
        </Button>
      );
    };

    const renderReportButton = () => {
      if (!isAdmin) return null;
      if (location.pathname !== "/admin") return null;
      return (
        <Button
          key="report"
          size="sm"
          smSize="sm"
          mdSize="md"
          variant="secondary"
          onClick={() => navigate("/admin/report")}
        >
          Raport lunar
        </Button>
      );
    };

    const renderFinancialButton = () => {
      if (!isStaff) return null;
      if (!showFinancialButton || typeof onOpenFinancial !== "function") return null;
      return (
        <Button
          key="financial"
          size="sm"
          smSize="sm"
          mdSize="md"
          variant="primary"
          onClick={onOpenFinancial}
        >
          💰 Financiar
        </Button>
      );
    };

    const buttons = [];
    const clinicButton = renderClinicButton();
    if (clinicButton) buttons.push(clinicButton);
    const reportButton = renderReportButton();
    if (reportButton) buttons.push(reportButton);
    const financialButton = renderFinancialButton();
    if (financialButton) buttons.push(financialButton);

    if (!isHomeRoute) {
      buttons.push(
        <Button key="home" size="sm" smSize="sm" mdSize="md" variant="secondary" onClick={() => navigate("/")}>
          Home
        </Button>
      );
    }
    buttons.push(
      <Button key="logout" size="sm" smSize="sm" mdSize="md" variant="danger" onClick={handleLogout}>
        Logout
      </Button>
    );

    return buttons;
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 backdrop-blur bg-white/20 shadow-sm">
      <div className="flex flex-wrap items-center justify-between safe-px py-2 sm:py-3 max-w-7xl mx-auto gap-3">
        <Logo />
        <div className="flex items-center justify-end safe-gap max-w-full gap-2 flex-nowrap sm:flex-wrap overflow-x-auto">
          <CommonButtons />
        </div>
      </div>
    </nav>
  );
}
